export default function WhatsAppButton() {
  const phoneNumber = '629501941';
  const message = encodeURIComponent('Hola, me gustaría solicitar información sobre el servicio de vaciado de pisos.');

  const handleClick = () => {
    window.open(`https://wa.me/34${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer animate-pulse"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-white text-2xl"></i>
    </button>
  );
}